// Güncellenmiş UpsertModal bileşeni
import React, { useEffect, useState } from "react"
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  InputNumber,
} from "antd"
import * as Http from "utils/http.helper"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import Maps from "components/map"
import * as moment from "moment"

const { TextArea } = Input

const stateCodeList = [
  { value: "AL", label: "Alabama (AL)" },
  { value: "AK", label: "Alaska (AK)" },
  { value: "AZ", label: "Arizona (AZ)" },
  { value: "AR", label: "Arkansas (AR)" },
  { value: "CA", label: "California (CA)" },
  { value: "CO", label: "Colorado (CO)" },
  { value: "CT", label: "Connecticut (CT)" },
  { value: "DE", label: "Delaware (DE)" },
  { value: "DC", label: "District Of Columbia (DC)" },
  { value: "FL", label: "Florida (FL)" },
  { value: "GA", label: "Georgia (GA)" },
  { value: "HI", label: "Hawaii (HI)" },
  { value: "ID", label: "Idaho (ID)" },
  { value: "IL", label: "Illinois (IL)" },
  { value: "IN", label: "Indiana (IN)" },
  { value: "IA", label: "Iowa (IA)" },
  { value: "KS", label: "Kansas (KS)" },
  { value: "KY", label: "Kentucky (KY)" },
  { value: "LA", label: "Louisiana (LA)" },
  { value: "ME", label: "Maine (ME)" },
  { value: "MD", label: "Maryland (MD)" },
  { value: "MA", label: "Massachusetts (MA)" },
  { value: "MI", label: "Michigan (MI)" },
  { value: "MN", label: "Minnesota (MN)" },
  { value: "MS", label: "Mississippi (MS)" },
  { value: "MO", label: "Missouri (MO)" },
  { value: "MT", label: "Montana (MT)" },
  { value: "NE", label: "Nebraska (NE)" },
  { value: "NV", label: "Nevada (NV)" },
  { value: "NH", label: "New Hampshire (NH)" },
  { value: "NJ", label: "New Jersey (NJ)" },
  { value: "NM", label: "New Mexico (NM)" },
  { value: "NY", label: "New York (NY)" },
  { value: "NC", label: "North Carolina (NC)" },
  { value: "ND", label: "North Dakota (ND)" },
  { value: "OH", label: "Ohio (OH)" },
  { value: "OK", label: "Oklahoma (OK)" },
  { value: "OR", label: "Oregon (OR)" },
  { value: "PA", label: "Pennsylvania (PA)" },
  { value: "RI", label: "Rhode Island (RI)" },
  { value: "SC", label: "South Carolina (SC)" },
  { value: "SD", label: "South Dakota (SD)" },
  { value: "TN", label: "Tennessee (TN)" },
  { value: "TX", label: "Texas (TX)" },
  { value: "UT", label: "Utah (UT)" },
  { value: "VT", label: "Vermont (VT)" },
  { value: "VA", label: "Virginia (VA)" },
  { value: "WA", label: "Washington (WA)" },
  { value: "WV", label: "West Virginia (WV)" },
  { value: "WI", label: "Wisconsin (WI)" },
  { value: "WY", label: "Wyoming (WY)" },
]

const categoryList = [
  { label: "Apparel", value: "Apparel", id: 1 },
  { label: "Print", value: "Print", id: 7 },
  { label: "Engraving", value: "Engraving", id: 3 },
]

const UpsertModal = props => {
  const [refForm] = Form.useForm()
  const [addressInfo, setAddressInfo] = useState(null)
  const [category, setCategory] = useState("Engraving")
  const [apparelOptions, setApparelOptions] = useState({})
  const [printOptions, setPrintOptions] = useState({})
  const [apparelPrices, setApparelPrices] = useState([])
  const [printPrices, setPrintPrices] = useState([])
  const [engravingPrices, setEngravingPrices] = useState([])

  const [apparelOptionsRaw, setApparelOptionsRaw] = useState([])
  const [printOptionsRaw, setPrintOptionsRaw] = useState([])

  const [filteredSizes, setFilteredSizes] = useState([])
  const [filteredColors, setFilteredColors] = useState([])

  useEffect(() => {
    refForm.setFieldsValue({ country: "USA" })
    fetchOptions()

    if (props.upsertModal?.data?.id) {
      const formData = props.upsertModal.data
      const findStateCode = stateCodeList.find(
        x => x.value === formData?.shipmentDetail?.stateCode
      )
      refForm.setFieldsValue({
        sku: formData?.sku,
        orderId: formData?.orderId,
        variant: formData?.variant,
        personalization: formData?.personalization,
        city: formData?.shipmentDetail?.city,
        quantity: formData?.quantity,
        stateCode: findStateCode?.value,
        nameSurname: formData?.shipmentDetail?.nameSurname,
        saleDate: new moment(formData.saleDate),
        zipCode: formData?.shipmentDetail?.zipCode,
        addressLine1: formData?.shipmentDetail?.addressLine1,
        addressLine2: formData?.shipmentDetail?.addressLine2,
        transactionId: formData?.transactionId,
        // price: formData?.price,
        styleId: formData?.styleId,
        sizeId: formData?.sizeId,
        colorId: formData?.colorId,
        categoryId: categoryList.find(c => c.value === category)?.id || 3,
      })
      setCategory(categoryList.find(c => c.value === category)?.id || 3)
    }
  }, [])

  useEffect(() => {
    if (addressInfo?.value?.place_id) {
      refForm.setFieldsValue({
        city:
          addressInfo?.value?.terms.length === 4
            ? addressInfo?.value?.terms[1]?.value
            : addressInfo?.value?.terms.length === 5
            ? addressInfo?.value?.terms[2]?.value
            : addressInfo?.value?.terms.length === 6
            ? addressInfo?.value?.terms[3]?.value
            : "",
        addressLine1:
          addressInfo?.value?.terms.length === 4
            ? addressInfo?.value?.terms[0]?.value
            : addressInfo?.value?.terms.length === 5
            ? addressInfo?.value?.terms[0]?.value +
              " " +
              addressInfo?.value?.terms[1]?.value
            : addressInfo?.value?.terms.length === 6
            ? addressInfo?.value?.terms[0]?.value +
              " " +
              addressInfo?.value?.terms[1]?.value
            : "",
        addressLine2:
          addressInfo?.value?.terms.length === 6
            ? addressInfo?.value?.terms[2]?.value
            : "",
        stateCode:
          addressInfo?.value?.terms.length === 4
            ? addressInfo?.value?.terms[2]?.value
            : addressInfo?.value?.terms.length === 5
            ? addressInfo?.value?.terms[3]?.value
            : addressInfo?.value?.terms.length === 6
            ? addressInfo?.value?.terms[4]?.value
            : "",
      })
    }
  }, [addressInfo])

  const fetchOptions = async () => {
    const [apparelRes, printRes, engravingRes, apparelProp, printProp] =
      await Promise.all([
        Http.get("api/orders/getproductspricesbycompany?categoryId=1"),
        Http.get("api/orders/getprintproductspricesbycompany?categoryId=7"),
        Http.get("api/orders/GetEngravingPricesByCompany"),
        Http.get("api/orders/GetAllProperties"),
        Http.get("api/orders/GetAllPrintProperties"),
      ])

    if (apparelRes?.success) setApparelPrices(apparelRes.data)
    if (printRes?.success) setPrintPrices(printRes.data)
    if (engravingRes?.success) setEngravingPrices(engravingRes.data)

    if (apparelProp?.success) {
      const styles = apparelProp.data.map(x => ({
        label: x.styleName,
        value: x.styleId,
      }))
      const sizes = [...new Set(apparelProp.data.flatMap(x => x.sizes))].map(
        x => ({ label: x.name, value: x.id })
      )
      const colors = [...new Set(apparelProp.data.flatMap(x => x.colors))].map(
        x => ({ label: x.name, value: x.id })
      )
      setApparelOptions({ styles, sizes, colors })
      setApparelOptionsRaw(apparelProp.data)
    }
    if (printProp?.success) {
      const styles = printProp.data.map(x => ({
        label: x.styleName,
        value: x.styleId,
      }))
      const sizes = [...new Set(printProp.data.flatMap(x => x.sizes))].map(
        x => ({ label: x.name, value: x.id })
      )
      const colors = [...new Set(printProp.data.flatMap(x => x.colors))].map(
        x => ({ label: x.name, value: x.id })
      )
      setPrintOptions({ styles, sizes, colors })
      setPrintOptionsRaw(printProp.data)
    }
  }

  const handleCategoryChange = value => {
    setCategory(value)
    refForm.setFieldsValue({
      styleId: undefined,
      sizeId: undefined,
      colorId: undefined,
      price: undefined,
    })
  }

  const lookupPrice = () => {
    const { styleId, sizeId, colorId } = refForm.getFieldsValue()
    let price = ""
    if (category === "Apparel") {
      price = apparelPrices.find(
        p =>
          p.styleId === styleId &&
          p.sizeId === sizeId &&
          (!p.colorId || p.colorId === colorId)
      )?.price
    } else if (category === "Print") {
      price = printPrices.find(
        p =>
          p.styleId === styleId &&
          p.sizeId === sizeId &&
          (!p.colorId || p.colorId === colorId)
      )?.price
    } else if (category === "Engraving") {
      const sku = refForm.getFieldValue("sku")?.toLowerCase()
      price = engravingPrices.find(p => p.sku?.toLowerCase() === sku)?.price
    }
    refForm.setFieldValue("price", price || "")
  }

  const onFinish = () => {
    const formValues = refForm.getFieldsValue()

    const obj = {
      id: props.upsertModal?.data?.id,
      recordName: props?.upsertModal?.data?.recordName,
      ...formValues,
      categoryId: categoryList.find(c => c.value === category)?.id || 3,
      country: "USA",
      saleDate:
        moment.utc(formValues.saleDate).format("YYYY-MM-DD") + "T00:00:00.000Z",
    }

    delete obj.searchMaps
    Http.post("api/orders/createManuelOrder", obj)
      .then(res => {
        if (res.success) {
          toastr.success("Process Success.")
          props.setLoading(false)
          props.onClose(true)
        } else {
          props.setLoading(false)
          toastr.error("Process Fail.")
        }
      })
      .catch(error => {
        props.setLoading(false)
        toastr.error(error.response?.data?.title || "Unexpected error")
      })
  }

  const getSizesForSelectedStyle = (styleId, category) => {
    const source = category === "Apparel" ? apparelOptions : printOptions
    const original =
      (category === "Apparel" ? apparelOptionsRaw : printOptionsRaw) || []
    const style = original.find(s => s.styleId === styleId)
    return style?.sizes.map(x => ({ label: x.name, value: x.id })) || []
  }

  const getColorsForSelectedStyle = (styleId, category) => {
    const source = category === "Apparel" ? apparelOptions : printOptions
    const original =
      (category === "Apparel" ? apparelOptionsRaw : printOptionsRaw) || []
    const style = original.find(s => s.styleId === styleId)
    return style?.colors.map(x => ({ label: x.name, value: x.id })) || []
  }

  return (
    <Modal
      centered
      cancelText="Close"
      width={950}
      confirmLoading={props.loading}
      maskClosable={false}
      title={
        props.upsertModal?.data?.id ? (
          <>
            Edit Order{" "}
            <span style={{ fontSize: 14 }}>
              <span style={{ opacity: "0.3" }}>[ Order: </span>
              {props.upsertModal?.data?.orderId}{" "}
              <span style={{ opacity: "0.3" }}>| Sku: </span>
              {props.upsertModal?.data?.sku}
              <span style={{ opacity: "0.3" }}> ]</span>
            </span>
          </>
        ) : (
          "Add New Order"
        )
      }
      open={props.upsertModal.show}
      onOk={() => refForm.validateFields().then(onFinish)}
      okText="Save"
      onCancel={() => props.onClose(false)}
    >
      <Form form={refForm} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col lg={8}>
            <Form.Item
              label="Category"
              name="category"
              rules={[{ required: true }]}
            >
              <Select
                options={[
                  { value: "Apparel" },
                  { value: "Print" },
                  { value: "Engraving" },
                ]}
                onChange={handleCategoryChange}
              />
            </Form.Item>
          </Col>
          <Col lg={8}>
            <Form.Item label="SKU" name="sku" rules={[{ required: true }]}>
              <Input onBlur={lookupPrice} />
            </Form.Item>
          </Col>
          <Col lg={8}>
            <Form.Item
              label="Order No"
              name="orderId"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={8}>
            <Form.Item
              label="Transaction Id"
              name="transactionId"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={8}>
            <Form.Item
              label="Name Surname"
              name="nameSurname"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={8}>
            <Form.Item
              label="Quantity"
              name="quantity"
              rules={[{ required: true }]}
            >
              <InputNumber min={1} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        {(category === "Apparel" || category === "Print") && (
          <Row gutter={[16, 16]}>
            <Col lg={8}>
              <Form.Item
                label="Style"
                name="styleId"
                rules={[{ required: true }]}
              >
                <Select
                  options={
                    (category === "Apparel" ? apparelOptions : printOptions)
                      .styles
                  }
                  onChange={value => {
                    refForm.setFieldsValue({
                      sizeId: undefined,
                      colorId: undefined,
                      price: undefined,
                    })
                    setFilteredSizes(getSizesForSelectedStyle(value, category))
                    setFilteredColors(
                      getColorsForSelectedStyle(value, category)
                    )
                    lookupPrice()
                  }}
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="Size"
                name="sizeId"
                rules={[{ required: true }]}
              >
                <Select options={filteredSizes} onChange={lookupPrice} />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item label="Color" name="colorId">
                <Select
                  options={filteredColors}
                  onChange={lookupPrice}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row gutter={[16, 16]}>
          <Col lg={8}>
            <Form.Item label="Price" name="price">
              <InputNumber min={0} style={{ width: "100%" }} disabled />
            </Form.Item>
          </Col>
          <Col lg={8}>
            <Form.Item
              label="Sale Date"
              name="saleDate"
              rules={[{ required: true }]}
            >
              <DatePicker style={{ width: "100%" }} format="DD.MM.YYYY" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={24}>
            <Form.Item
              label="Variant"
              name="variant"
              rules={[{ required: true }]}
            >
              <TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={24}>
            <Form.Item
              label="Personalization"
              name="personalization"
              rules={[{ required: false }]}
            >
              <TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={24}>
            <Form.Item label="Search Address" name="searchMaps">
              <Maps setValue={setAddressInfo} value={addressInfo} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={6}>
            <Form.Item
              label="Country"
              name="country"
              rules={[{ required: true }]}
            >
              <Select
                disabled
                options={[
                  { value: "USA", label: "United States of America (USA)" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              label="State"
              name="stateCode"
              rules={[{ required: true }]}
            >
              <Select options={stateCodeList} />
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item label="City" name="city" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              label="ZipCode"
              name="zipCode"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={12}>
            <Form.Item label="Address" name="addressLine1">
              <TextArea rows={2} />
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item label="Apartment/Suit" name="addressLine2">
              <TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default UpsertModal
